var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArraowLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10361_11255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5951 10.0278C29.1993 9.8956 28.8308 9.99122 28.6476 10.0444C28.448 10.1024 28.2101 10.1953 27.9714 10.2885L11.0143 16.9059C10.7475 17.01 10.489 17.1108 10.2895 17.2095C10.1172 17.2947 9.75084 17.4844 9.54635 17.878C9.32085 18.312 9.32115 18.8288 9.54717 19.2626C9.75212 19.6559 10.1187 19.8452 10.2911 19.9302C10.4907 20.0286 10.7492 20.1291 11.0162 20.2329L17.7275 22.8428L20.3374 29.554C20.4412 29.821 20.5417 30.0796 20.6401 30.2792C20.7251 30.4516 20.9144 30.8182 21.3077 31.0231C21.7415 31.2492 22.2583 31.2495 22.6923 31.024C23.086 30.8195 23.2756 30.4531 23.3609 30.2808C23.4595 30.0813 23.5603 29.8229 23.6644 29.5561L30.2818 12.5989C30.375 12.3602 30.4679 12.1223 30.5259 11.9227C30.5791 11.7395 30.6747 11.371 30.5425 10.9752C30.3931 10.5281 30.0422 10.1772 29.5951 10.0278Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10361_11255",
    x: 0.0774412,
    y: 0.660937,
    width: 39.8319,
    height: 39.8319,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.65
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10361_11255"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10361_11255",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArraowLocation);
export default __webpack_public_path__ + "static/media/arraow-location.08d92178776aa3eb3c5138d2a9588342.svg";
export { ForwardRef as ReactComponent };